// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Connection } from './Commons/Connection';
import { BrowserUtils } from '@shared/utils/BrowserUtils';
import { Md5 } from 'ts-md5';
class BaseRoute {
    constructor(createRequestPromise) {
        this.createRequestPromise = createRequestPromise;
    }
}
class Settings extends BaseRoute {
    getWebMobile() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'settings/webMobile');
        });
    }
    postWebMobile(dbRecord) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isValidString(UserWebStorage.authData)) {
                yield Promise.resolve();
                return;
            }
            return this.createRequestPromise('POST', 'settings/webMobile', dbRecord).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    getWatchlistSheets() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'settings/watchlistSheets');
        });
    }
    postWatchlistSheets(dbRecord) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isValidString(UserWebStorage.authData)) {
                yield Promise.resolve();
                return;
            }
            return this.createRequestPromise('POST', 'settings/watchlistSheets', dbRecord).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'settings');
        });
    }
    post(dbRecord) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isValidString(UserWebStorage.authData)) {
                yield Promise.resolve();
                return;
            }
            return this.createRequestPromise('POST', 'settings', dbRecord).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    getPortfolioSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'settings/portfolio').catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    postPortfolioSettings(settings) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isValidString(UserWebStorage.authData)) {
                yield Promise.resolve();
                return;
            }
            return this.createRequestPromise('POST', 'settings/portfolio', settings).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
}
class Workspaces extends BaseRoute {
    getInitData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'workspaces/init-data').catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    getDefaultData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'workspaces/default').catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'workspaces/' + id).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    update(id, obj) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('PUT', 'workspaces/' + id, obj).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    create(id, obj) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('POST', 'workspaces/' + id, obj).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    clone(srcId, destId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('POST', 'workspaces/' + srcId + '/' + destId).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    setActiveWorkspaceId(wsId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('PUT', 'workspaces/active/' + wsId).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
    delete(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('DELETE', 'workspaces/', ids).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
}
class TvWorkspaces extends BaseRoute {
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'tv-workspaces/' + id).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (e === 204) {
                        // first logon no workspace
                        return yield Promise.resolve(null);
                    }
                    return yield Promise.reject(e);
                });
            });
        });
    }
    put(id, obj) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('PUT', 'tv-workspaces/' + id, obj).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
}
class WebAdmin extends BaseRoute {
    post(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('POST', 'web-admin', params);
        });
    }
}
class Branding extends BaseRoute {
    locales(connectionName) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'branding/locales/' + connectionName);
        });
    }
}
class Connections extends BaseRoute {
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('GET', 'connections');
        });
    }
}
/**
 * https://tp.traderevolution.com/entity/86122
 */
class ExternalResourse extends BaseRoute {
    post(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const encodedURL = encodeURIComponent(url);
            return this.createRequestPromise('POST', 'external-resourse', { encodedURL }).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
}
/**
 * https://tp.traderevolution.com/entity/114288
 */
class YoutubePageParser extends BaseRoute {
    post(url, videoId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.createRequestPromise('POST', 'youtube-parser', { url, videoId }).catch(function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    return yield Promise.reject(e);
                });
            });
        });
    }
}
/* ================== TODO. Refactor. Rename. ================== */
export class UserWebStorage {
    get ipAddress() {
        return this._ipAddress;
    }
    constructor() {
        this._ipAddress = '';
        const createRequestPromise = this.createRequestPromise.bind(this);
        this.settings = new Settings(createRequestPromise);
        this.workspaces = new Workspaces(createRequestPromise);
        this.tvWorkspaces = new TvWorkspaces(createRequestPromise);
        this.webAdmin = new WebAdmin(createRequestPromise);
        this.branding = new Branding(createRequestPromise);
        this.connections = new Connections(createRequestPromise);
        this.externalResourse = new ExternalResourse(createRequestPromise); // https://tp.traderevolution.com/entity/86122
        this.youtubePageParser = new YoutubePageParser(createRequestPromise); // https://tp.traderevolution.com/entity/114288
        this.urlRoot = null;
        UserWebStorage.authData = null;
        UserWebStorage.RestApiNotWork = false; // if 400 responce
    }
    applyIPAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRequestPromise('GET', '/get-ip', undefined);
            this._ipAddress = response.ip ? response.ip : '';
        });
    }
    getVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.createRequestPromise('GET', '/version', undefined);
                return response.version;
            }
            catch (_a) {
                return '';
            }
        });
    }
    reinit(userSessionId, connectionName) {
        if (!isValidString(userSessionId) || !isValidString(connectionName)) {
            throw Error('Insufficient auth data.');
        }
        UserWebStorage.authData = Md5.hashStr(connectionName);
    }
    clear() {
        UserWebStorage.authData = null;
    }
    createRequestPromise(type, url, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const authData = UserWebStorage.authData;
            const urlRoot = this.urlRoot;
            const contentTypeJson = 'application/json';
            let token = '';
            if (Connection === null || Connection === void 0 ? void 0 : Connection.ConnectResultData) {
                token = Connection.ConnectResultData.ConnectResultData.accessToken;
            }
            return yield new Promise(function (resolve, reject /*, onCancel */) {
                const xhr = new XMLHttpRequest();
                // onCancel(function () { xhr.abort(); });
                let resUrl = urlRoot ? urlRoot + url : url;
                // IE ignores etag and forcibly caches get requests. Screw ie.
                if (BrowserUtils.isIE() && type === 'GET') {
                    resUrl += '?req_id=' + new Date().getTime();
                }
                xhr.open(type, resUrl);
                xhr.setRequestHeader('Auth-Data', authData);
                if (token) {
                    xhr.setRequestHeader('Auth-Token', token);
                }
                xhr.setRequestHeader('Content-Type', contentTypeJson);
                xhr.onreadystatechange = function () {
                    if (this.readyState !== /* DONE */ 4) {
                        return;
                    }
                    if (this.status !== 200) {
                        reject(this.status);
                        return;
                    }
                    const contentType = this.getResponseHeader('Content-Type') || '';
                    resolve(contentType.includes(contentTypeJson) ? JSON.parse(this.responseText) : null);
                };
                xhr.send(body ? JSON.stringify(body) : null);
            });
        });
    }
}
UserWebStorage.RestApiNotWork = false;
UserWebStorage.authData = null;
export const UserWebStorageInstance = new UserWebStorage();
